"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  BackgroundTasks: () => BackgroundTasks
});
module.exports = __toCommonJS(unavailable_exports);
var import_validate = require("./validate");
var BackgroundTasks = Object.freeze({
  defineTask: function defineTask(identifier, handler) {
    (0, import_validate.validateDefinition)(identifier, handler);
    return function() {
    };
  },
  submit: function submit(identifier) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, import_validate.validateSubmission)(identifier, options.earliestBeginDateMs);
    return Promise.resolve();
  },
  getPending: function getPending() {
    return Promise.resolve([]);
  },
  cancel: function cancel(identifier) {
    (0, import_validate.validateCancellation)(identifier);
  }
});
//# sourceMappingURL=unavailable.js.map
